var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAds({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88234 7.17648H4.58823C3.90179 7.17648 3.24346 7.44916 2.75807 7.93455C2.27269 8.41994 2 9.07826 2 9.7647V21.4117C2 22.0982 2.27269 22.7565 2.75807 23.2419C3.24346 23.7273 3.90179 23.9999 4.58823 23.9999H16.2352C16.9217 23.9999 17.58 23.7273 18.0654 23.2419C18.5508 22.7565 18.8235 22.0982 18.8235 21.4117V20.1176M17.5293 4.58836L21.4117 8.4707M23.204 6.63953C23.7137 6.12985 24 5.43857 24 4.71778C24 3.99698 23.7137 3.3057 23.204 2.79602C22.6943 2.28634 22.0031 2 21.2823 2C20.5615 2 19.8702 2.28634 19.3605 2.79602L8.47055 13.6472V17.5295H12.3529L23.204 6.63953Z",
    stroke: "#4B2D10",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds);
export default __webpack_public_path__ + "static/media/ads.3a3ef6efe0829e1b1d78080f7e556374.svg";
export { ForwardRef as ReactComponent };